<template>
    <div>
        <MyJobsTray :status=status  @MyJobTrayLabStatus5WantToSwapTabToView="MyJobTrayLabStatus5WantToSwapTabToView" />
    </div>
</template>

<script>
    import MyJobsTray from "./MyJobsTray";


    export default {
        name: "MyJobTrayInComplete",
        components:{
            MyJobsTray
        },
        props:{
            status : Number
        },
        methods: {
            MyJobTrayLabStatus5WantToSwapTabToView(tmpDat){
                this.$emit('MyJobTrayLabStatus5WantToSwapTabToView',tmpDat)
            }
        }
    }
</script>

<style scoped>

</style>